import { MessagePreview } from '@tribeplatform/gql-client/types'
import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

import { useStaticIntl } from '../../../i18n/hooks/useStaticIntl.js'
import { previewHtmlContent } from '../../utils.js'
import { chatLogMessageFactory } from '../utils/chat.utils.js'

import { EmbedAttachmentPreview } from './EmbedAttachmentPreview.js'
import { FileAttachmentPreview } from './FileAttachmentPreview.js'
import { ImageAttachmentPreview } from './ImageAttachmentPreview.js'

interface Props {
  message: MessagePreview
}

export const LastMessagePreview = ({ message }: Props) => {
  const { attachmentsCount, embedsCount, imagePreview, preview, meta } = message
  const getChatLogMessage = useStaticIntl(chatLogMessageFactory)
  const { data: authMember } = useAuthMember()

  if (meta) {
    // Edit group can have multiple messages, which all are displayed in the messages list
    // however, here we only want to display the first message.
    const [msg] = getChatLogMessage(message, authMember)
    return <span className="truncate">{msg}</span>
  }

  return (
    <div className="flex items-center gap-x-1 truncate">
      {!!imagePreview && <ImageAttachmentPreview previewMessage={message} />}
      {!!attachmentsCount && <FileAttachmentPreview previewMessage={message} />}
      {!!embedsCount && <EmbedAttachmentPreview previewMessage={message} />}
      {preview && (
        <div className="inline-block min-w-0 truncate" dir="auto">
          {previewHtmlContent(preview)}
        </div>
      )}
    </div>
  )
}
